import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { deleteInventorySystemProfileToVenue } from '../../services/api/deleteInventorySystemProfileToVenue'
import { ConfirmDeleteEntityPage } from '../ConfirmDeleteEntityPage/ConfirmDeleteEntityPage'

export function InventorySystemProfileToVenueDeletePage() {
  const { ispId, venueId } = useParams<{ ispId: string; venueId: string }>()
  const navigate = useNavigate()
  const { getToken } = useAuth()

  async function handleConfirm() {
    await deleteInventorySystemProfileToVenue(await getToken(), ispId!, venueId!)
    navigate('/isp-to-venues')
  }

  return (
    <ConfirmDeleteEntityPage
      entityLabel="ISP to Venue Mapping"
      title={`ISP ${ispId} → Venue ${venueId}`}
      cancelTo={`/isp-to-venues/${ispId}/${venueId}`}
      onConfirm={handleConfirm}
      isLoading={false}
      loadError={null}
    />
  )
}
